import { Injectable, Injector } from '@angular/core';
import { ErrorMessage } from './error-message';
import { AlertService } from './alert.service';

@Injectable({
    providedIn: 'root'
})
export class MessageHandlerService {
    //private _translate: TranslateService;

    constructor(private _alertService: AlertService, private _injector: Injector) {}

    /**
     * Felhasználó nincs bejelentkezve hibaüzenetet tartalmaz
     * a megadott lista.
     * @param errorMessages Hibaüzenetek
     */
    getUserNotLoggedInMessage(errorMessages: ErrorMessage[]): ErrorMessage {
        return errorMessages.find((message) => message.messageNumber == '2288')!;
    }

    /**
     * Ha a success mező false, megjelenít egy default üzenetet.
     * Feldolgozza és megjeleníti a paraméterben kapott üzeneteket.
     * @param success Sikeres volt-e a művelet
     * @param errorMessages Hibaüzenetek
     */
    showMessages(
        errorMessages: ErrorMessage[],
        success = false,
        keepAfterRouteChange = false
    ): void {
        // Ha hiba történt, de az errorMessages nem tartalmaz hármas vagy
        // négyes szintű hibaüzenetet, akkor default hibaüzenetet küld
        // if (!success && errorMessages && !errorMessages.some((row) => row.severity >= 3)) {
        //     this._ensureTranslateServiceInitialized();
        //     this._alertService.error(
        //         this._translate.instant('errorService.message.requestError') as string
        //     );
        // // }
        errorMessages?.forEach((row) => {
            switch (Number(row.severity)) {
                case 1:
                    this._alertService.information(row.messageText, keepAfterRouteChange);
                    break;
                case 2:
                    this._alertService.warning(row.messageText, keepAfterRouteChange);
                    break;
                case 3:
                case 4:
                    this._alertService.error(row.messageText, keepAfterRouteChange);
                    break;
                default:
                    break;
            }
        });
    }

    // private _ensureTranslateServiceInitialized(): void {
    //     if (!this._translate) this._translate = this._injector.get(TranslateService);
    // }
}
